import { DetectionInstructions } from './detectionInstructions'
import DynamicInputs from '../../../../../../../components/DynamicInputs'
import { usePolicyParametersContext } from '../../../../context/policyParametersContext'
import { useReduxSelector } from '../../../../../../../hooks/useReduxSelector'
import { validateString } from '../../../../../../attributes/settings/utils'
import { ValidationRules } from '../../../../../../attributes/settings/constants'
import React, { useMemo } from 'react'
import { Typography } from '@lightbeamai/design-system'
import { Check, Warning, X } from 'phosphor-react'
import { useIntl } from 'react-intl'

export const DetectionKeys = () => {
  const intl = useIntl()
  const { detection, patchDetection, mode } = usePolicyParametersContext()
  const { contextWords } = detection
  const setContextWords = (contextWords: string[]) => patchDetection({ contextWords })
  const { isView } = mode

  const validationResult = useReduxSelector((state) => state.attributes.validationResult)
  const contextMatches = useMemo(() => validationResult?.contextMatches || {}, [validationResult])

  const suffixContent = !validationResult
    ? []
    : contextWords.map((val, index) => {
        if (!val) return null
        const matchedCount = contextMatches[val]?.length || 0

        return (
          <Typography
            key={`suffix-content-ca-${index}`}
            variant="baseMinus2"
            color="custom"
            style={{ color: matchedCount ? '#406E00' : '#8A1000' }}
            className="flex-row align-center"
          >
            {matchedCount ? (
              <Check size={16} color="currentColor" />
            ) : (
              <X size={16} color="currentColor" />
            )}
            <span className="xs-ml-4">
              {intl.formatMessage(
                { id: 'attributeManagementSettings.customAttributes.matches' },
                { matched: matchedCount }
              )}
            </span>
          </Typography>
        )
      })

  return (
    <div className="key-value-configuration-card detection-keys">
      <DetectionInstructions transIdKey="detectionKeys" />

      <div className=" xs-my-16">
        <DynamicInputs
          transId="dynamicKeyLabel"
          inputs={contextWords}
          setInputs={setContextWords}
          disabled={isView}
          suffixContent={suffixContent}
          validate={(val) => validateString(val, 3, 100)}
          messages={[
            {
              rule: ValidationRules.min_length,
              type: 'error',
              value: (
                <Typography as="span" color="error" variant="baseMinus2">
                  {intl.formatMessage({
                    id:
                      'attributeManagementSettings.customAttributes.detection.keyValue.detectionKeys.error.min_length'
                  })}
                </Typography>
              )
            },
            {
              rule: ValidationRules.special_characters,
              type: 'error',
              value: (
                <Typography as="span" color="error" variant="baseMinus2">
                  {intl.formatMessage({
                    id:
                      'attributeManagementSettings.customAttributes.detection.keyValue.detectionKeys.error.special_characters'
                  })}
                </Typography>
              )
            },
            {
              rule: ValidationRules.common_words,
              type: 'warning',
              value: (
                <Typography as="span" color="warning" variant="baseMinus2">
                  <Warning />
                  {intl.formatMessage({
                    id:
                      'attributeManagementSettings.customAttributes.detection.keyValue.detectionKeys.error.common_words'
                  })}
                </Typography>
              )
            }
          ]}
        />
      </div>
    </div>
  )
}
